/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * [description]
 *
 * @function Phaser.Math.Easing.Linear
 * @since 3.0.0
 *
 * @param {number} v - [description]
 *
 * @return {number} [description]
 */
var Linear = function (v)
{
    return v;
};

module.exports = Linear;



//////////////////
// WEBPACK FOOTER
// ./math/easing/linear/Linear.js
// module id = 622
// module chunks = 0